export default __webpack_public_path__ + "static/media/closet2-1024w.b4a327a4.png";